export default __webpack_public_path__ + "static/media/bun_bottom.bd348406.svg";